/* eslint-disable no-underscore-dangle */
import React from 'react';
// import { PortaisTypes } from 'store/modules/my_history_store/types';
import { PortalResumo } from 'store/modules/my_history_store/types';
import { Container } from './styles';

interface ListPortaisProps {
  listPortais: PortalResumo[];
}

const ListPortais = (props: ListPortaisProps) => {
  const { listPortais } = props;
  return (
    <Container>
      <div className="table-responsive">
        <table className="table table-bordered">
          <thead className="thead-light">
            <tr>
              <th scope="col">Nome do Portal</th>
              <th scope="col">Licitações</th>
              <th scope="col">Investimento</th>
            </tr>
          </thead>
          <tbody>
            {listPortais?.length === 0 && (
              <tr>
                <td colSpan={6} className="text-center border-0 pb-0">
                  <div className="alert alert-secondary m-0" role="alert">
                    <p className="mb-0">Não foram encontrados resultados para este filtro.</p>
                  </div>
                </td>
              </tr>
            )}
            {listPortais?.map((portal) => (
              <tr>
                <td>{portal?.portal}</td>
                <td>{portal?.licitacoes}</td>
                <td>
                  {portal?.investimento.toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                  })}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Container>
  );
};

export default ListPortais;
